import {useMapContext} from '@/components/MindMap/index.mjs'
import NodeExtraText from './NodeExtraText.jsx'

export default function NodeUpper({node, ...props}) {
    const map = useMapContext()
    const _n = map.nodeProxy(node)
    const text = _n.getTextUpper?.()

    if (! text) {
        return null
    }

    return (
        <NodeExtraText
            node={node}
            text={text}
            {...props}
        />
    )
}
